import { t } from 'i18next';
import { IArtistNameResponse } from 'services/artists/types';
import { ISettlementPeriodName } from 'services/label-report/types';

const getFilledString = (text?: string) => (text?.trim().length ? text : null);

export const getArtistName = (
  name?: IArtistNameResponse
): string | undefined => {
  if (!name) {
    return undefined;
  }

  const prefix = getFilledString(name.prefix) ?? '';
  const firstName = getFilledString(name.firstName) ?? '';
  const lastName = getFilledString(name.lastName) ?? '';
  const suffix = getFilledString(name.suffix) ?? '';

  if (!prefix && !firstName && !lastName && !suffix) {
    return undefined;
  }

  return `${prefix} ${firstName} ${lastName} ${suffix}`;
};

export const getSettlementPeriodName = <T extends ISettlementPeriodName>(
  settlement?: T | null
) =>
  settlement
    ? `${t(`enum.MONTH.${settlement.name}`)} ${settlement.year}`
    : undefined;
